var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0V0z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"currentColor","d":_vm.path}})])}
var staticRenderFns = []

export { render, staticRenderFns }